import type { SaveBarButtonsProps } from "./save-bar-buttons.type";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

export const SaveBarButtons = ({
  hasChanges,
  disabled,
  onCancel,
  onSave,
}: SaveBarButtonsProps) => {
  const { t } = useTranslation();

  if (!hasChanges) return null;

  return (
    <span className="save-bar-buttons">
      {onCancel && (
        <Button
          htmlType="submit"
          disabled={disabled}
          onClick={onCancel}
          data-testid="cancel"
        >
          {t("global:cancel")}
        </Button>
      )}
      {onSave && (
        <Button
          type="primary"
          htmlType="submit"
          disabled={disabled}
          onClick={onSave}
          data-testid="savebar-save-button"
        >
          {t("global:save")}
        </Button>
      )}
    </span>
  );
};
